module.exports = __webpack_public_path__ + "img/jzqlogo.3c11c83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/jzqlogo.png
// module id = yirs
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37